export function transformResourceTagData(_a) {
    var resource_tag_name = _a.resource_tag_name;
    return { name: resource_tag_name };
}
export function transformResourceTagForm(formState) {
    return { resource_tag_name: formState.name };
}
